import { Controller } from '@hotwired/stimulus'

export default class AdminPrepareSyncWithAircapFormController extends Controller {
  static targets = ['inputType', 'inputTransferApprovalThresholdAmount'];

  connect() {
    this.initInputTypeWatch();
  }

  initInputTypeWatch(ev) {
    $(this.inputTypeTarget).on('change', (ev) => {
      if (ev.target.value == 'open-banking') {
        this.inputTransferApprovalThresholdAmountTarget.value = '';
        this.inputTransferApprovalThresholdAmountTarget.disabled = true;
      } else {
        this.inputTransferApprovalThresholdAmountTarget.disabled = false;
      }
    });
  }
}
